module.exports = __webpack_public_path__ + "img/number1.0b1fc90b.png";